import React, { FC, useEffect, useLayoutEffect } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ResolveThunks, connect } from "react-redux";
import Img from "@insite/mobius/Img";
import { getGaTagforL1L2 , bannerButtonGaTagV2} from "@NA/Utils/GtmUtility";
import translate from "@insite/client-framework/Translate";
import { css } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { GridOffset } from "@insite/mobius/GridContainer";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
//import jQuery from "jquery";
export interface gaTaggingStyles {
    monthlyflyerMaincontainer: InjectableCss;
    containerCard: InjectableCss;
    textContent: InjectableCss;
    contentHeading:InjectableCss;
    contentPara:InjectableCss;
    contentLink:InjectableCss;
    containerImg:InjectableCss;
    monthlyflyerimgContainer: InjectableCss;
    monthlyflyerimgLink: InjectableCss;

}
export const gaTaggingStyles: gaTaggingStyles = {
    monthlyflyerMaincontainer: {
        css: css`
            display:flex;           
            >  ${GridOffset} {
                width:100%;
                padding: 0 15px;               
                margin: 90px 0;
                display: flex;
                flex-flow: row;
                gap: 20px;
                background-color: rgb(255, 255, 255);
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css`flex-flow: column;`,], "max",);
                }}  
            }
        `,
    },
    containerCard: {
        css: css`
            position:relative;
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            padding:0px;
            margin:0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css`width: 100%;max-width: 100%;flex-basis: 100%; `,], "max",);
            }}  
        `,

    },
    containerImg: {
        css: css`
        height:auto;
    `,
    },
    monthlyflyerimgLink: {
        css: css`
        width: 100%;
        > span {
            width: 100%; 
        }
    `,
    },
    monthlyflyerimgContainer: {
        css: css`
        background-image: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Category/cate-proav.png);
        background-size: 100% 100%;
        min-height: 650px;
        width: 100%;
        max-width: 1440px;
        margin: 0 auto;
        background-repeat: no-repeat;
        position: relative;
        cursor: pointer;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme, [null, css`width: 100%;max-width: 100%;flex-basis: 100%; `,], "max",);
        }} 
    `,
    },
    textContent: {
        css: css`
        position: absolute;
        top: 48.9%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-height: 272px;
        padding: 0;
        background-color: rgba(0, 0, 0, .3);
        width: 100%;
        margin: 0 auto;
        max-width: 1440px;
        `,
    },
    contentHeading: {
        css: css`
        font-size: 75px;
        font-weight: 600;
        font-style: normal;
        line-height: normal;
        text-align: center;
        color: #fff;
        padding-top: 20px;
        display: block;
        `,
    },
    contentPara: {
        css: css`
        font-size: 40px;
    font-weight: 600;
    font-style: normal;
    line-height: normal;
    text-align: center;
    color: #fff;
    margin-bottom: 30px;
    padding: 0 15px;
    display: block;
        `,
    },
    contentLink: {
        css: css`
        min-width: 165px;
        width: 165px;
        height: 40px;
        flex-grow: 0;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border-radius: 4px;
        border: solid 1px #004da6;
        background-color: #fff;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        line-height: normal;
        text-align: center;
        color: #004da6;
        margin: 0 auto;
        display: flex;
        font-family: "Nunito Sans", sans-serif;
        margin-bottom: 30px;
        `,
    },

    
}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        session: state.context.session,
    };
};
const enum fields {
    title1="monthly-sales-flyer",
    title2="Shop the Monthly Sales Flyer",
    title3="Get the best deals all in one place",
    }
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapStateToProps>;

export const ADIMonthlySalesFlyerL1 = ({ session }: Props) => {
    const displayPlaceHolderImageBasedOnAuth = () => {
        return (
            <GridContainer {...gaTaggingStyles.monthlyflyerMaincontainer} className="Nitesh">
                    <GridItem {...gaTaggingStyles.containerCard}>
                        <Link  href="/MyAccount/MonthlyFlyer" {...gaTaggingStyles.monthlyflyerimgLink} data-ga-promo={getGaTagforL1L2(fields.title1, "", "")}>
                            <StyledWrapper {...gaTaggingStyles.monthlyflyerimgContainer}>                               
                                <StyledWrapper {...gaTaggingStyles.textContent} >
                                    <Typography {...gaTaggingStyles.contentHeading}>{fields.title2}</Typography>
                                    <Typography {...gaTaggingStyles.contentPara}>{fields.title3}</Typography>
                                    <Typography data-ga-promo={getGaTagforL1L2(fields.title1, "", "Shop Now")} {...gaTaggingStyles.contentLink}>{translate("Shop Now")}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Link>
                    </GridItem>                                     
            </GridContainer>
        );
    };

    return (
        <>
            {
                displayPlaceHolderImageBasedOnAuth()
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ADIMonthlySalesFlyerL1),
    definition: {
        group: "Common",
        displayName: "Shop the Monthly Sales Flyer",
        fieldDefinitions: [],
    },
};

export default widgetModule;
